import { render } from "./ApplicationModalSide.vue?vue&type=template&id=67c5fdc8"
import script from "./ApplicationModalSide.vue?vue&type=script&lang=js"
export * from "./ApplicationModalSide.vue?vue&type=script&lang=js"

import "./ApplicationModalSide.vue?vue&type=style&index=0&id=67c5fdc8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__